/**
 * Remetente da lista "sempre exibir imagens de" (ADR 0045).
 *
 * A entrada vale pelo endereço inteiro (`carla@construtora.com.br`) ou pelo
 * domínio (`construtora.com.br`). Domínio é igualdade, não sufixo: confiar em
 * `empresa.com.br` não pode liberar `empresa.com.br.golpe.io`, e subdomínio
 * de marketing (`news.empresa.com.br`) é exatamente o remetente que rastreia.
 */
export function remetenteConfiavel(endereco: string | undefined, lista: string[]): boolean {
  if (endereco === undefined || lista.length === 0) return false;
  const e = endereco.trim().toLowerCase();
  const dominio = e.slice(e.lastIndexOf('@') + 1);
  return lista.some((item) => item === e || item === dominio);
}
